/* eslint-disable max-lines */
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import maxBy from 'lodash/maxBy';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import constants from '../../Checkout/Checkout.constants';
import { buildStorePageUrlSuffix, getAPIConfig } from '../../../../../utils/utils';
import { getCurrencySymbol } from '../../common/organism/OrderLedger/container/orderLedger.selector';

const getOdmLoading = (state) => {
  return state.Confirmation && state.Confirmation?.get('loading');
};

const getOrderConfirmation = (state) => {
  return state.Confirmation && state.Confirmation?.get('orderConfirmation');
};

export const getOrderConfirmationCartItems = (state) => {
  let orderProducts = state.Confirmation && state.Confirmation?.get('cartOrderItems');
  if (!orderProducts || orderProducts?.length === 0) {
    orderProducts = state.Confirmation && state.Confirmation?.get('orderProducts');
  }
  return orderProducts;
};

// TODO : Skipping it as it will be fixed after the immutable decision
// ignoring it with istanbul ignore also.
/* istanbul ignore next */
const getConfirmationSummary = createSelector(getOrderConfirmation, (confirmation) => {
  return confirmation && confirmation.summary;
});

/* istanbul ignore next */
export const getOrderEmailAddress = createSelector(getOrderConfirmation, (confirmation) => {
  return confirmation && confirmation?.userDetails && confirmation?.userDetails?.emailAddress;
});

// TODO : Skipping it as it will be fixed after the immutable decision
// ignoring it with istanbul ignore also.
/* istanbul ignore next */
const getItemsCount = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.itemsCount;
});

/* istanbul ignore next */
const getSubTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.subTotal;
});

/* istanbul ignore next */
const getGrandTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.grandTotal;
});

/* istanbul ignore next */
const getGiftCardsTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.giftCardsTotal;
});

/* istanbul ignore next */
const getTotalTax = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.taxesTotal;
});

/* istanbul ignore next */
const getCouponsTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.couponsTotal;
});

/* istanbul ignore next */
const getSavingsTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.savingsTotal;
});

/* istanbul ignore next */
const getShippingTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.shippingTotal;
});

/* istanbul ignore next */
const getHoldDate = createSelector(getOrderConfirmation, (orderConfirmation) => {
  return orderConfirmation && orderConfirmation.holdDate;
});
/* istanbul ignore next */
const getIsOrderHasShipping = createSelector(getOrderConfirmation, (orderConfirmation) => {
  return (
    orderConfirmation && orderConfirmation.shipping && orderConfirmation.shipping.itemsCount > 0
  );
});

const getAllShipments = (state) => {
  const orderConfirmation = state?.Confirmation?.get('orderConfirmation');
  return orderConfirmation?.shipments;
};

export const getConfirmationProductTotal = (state) => {
  const orderConfirmation = state?.Confirmation?.get('orderConfirmation');
  return orderConfirmation?.orderDetails?.productTotal;
};

// added temp this getC_s Runable remove it with once c_orderId adding to web
const getCsthOrderNo = (state) => {
  const orderConfirmation = state?.Confirmation?.get('orderConfirmation');
  return orderConfirmation?.c_sthOrderNo;
};

const getOrderNoArray = (state) => {
  const orderConfirmation = state?.Confirmation?.get('orderConfirmation');
  return orderConfirmation?.orderNoArray;
};

// FIXME: This needs to be re-writen... it seems this is meant to deal with a mixed order/Bopis order, if not a mixed order it returns null
/* istanbul ignore next */
const getFullfilmentCentersMap = createSelector(getOrderConfirmation, (orderConfirmation = {}) => {
  // Check that BOSS/BOPIS is from the same store as store selection can not be more than 2
  const isSamePickUpStore =
    (orderConfirmation &&
      orderConfirmation.totalsByFullfillmentCenterMap &&
      orderConfirmation.totalsByFullfillmentCenterMap.length > 1 &&
      orderConfirmation.totalsByFullfillmentCenterMap[0].id ===
        orderConfirmation.totalsByFullfillmentCenterMap[1].id) ||
    false;

  // Only Bopis Order Confirmation Info
  const pickupStores =
    orderConfirmation && orderConfirmation.totalsByFullfillmentCenterMap
      ? orderConfirmation?.totalsByFullfillmentCenterMap?.map((elem) => {
          return {
            ...elem,
            isSamePickUpStore,
            storeLink: {
              to: `/store/?storeStr=${buildStorePageUrlSuffix(elem)}`,
              asPath: `/store/${buildStorePageUrlSuffix(elem)}`,
            },
          };
        })
      : null;
  // Shipping Order Info
  const { shipping } = orderConfirmation;

  // sth stand for ship to home, we should slap the person who wrote this.
  let sth;

  // this gets the ecom order and adds data to it, Why in the holy hells name is this not in the abstractor??
  if (shipping) {
    const { address } = shipping;
    const { firstName, lastName } = address;
    sth = [
      {
        shippingFullname: `${firstName} ${lastName}`,
        productsCount: shipping.itemsCount,

        orderDate: shipping.orderDate,
        orderNumber: orderConfirmation?.orderDetails?.orderNumber,
        orderLink: shipping.orderLink,
        orderTotal: shipping?.orderTotal,

        emailAddress: shipping.emailAddress,
        encryptedEmailAddress: shipping.encryptedEmailAddress,
        isShippingWithSinglePickup: (pickupStores && pickupStores.length === 1) || false,
      },
    ];
  } else {
    return pickupStores;
  }

  /*  Given the logic if this order has an ecom order but
      no BOPIS then return null, or neither... this needs to all be consolidated into
      a single operator to deal with a ECOM/BOPIS/mixed order.
  */
  return pickupStores ? pickupStores.concat(sth) : null;
});

/* istanbul ignore next */
const getInitialCreateAccountValues = createSelector(getOrderConfirmation, (orderConfirmation) => {
  return orderConfirmation && orderConfirmation.userDetails;
});

const getEarnedPlaceCashValue = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.valueOfEarnedPcCoupons;
});

const getPersonalizedCoupons = (state) => {
  return state.Confirmation && state.Confirmation?.get('aquiredCouponCode');
};

/* istanbul ignore next */
const getEncryptedEmailAddress = createSelector(getOrderConfirmation, (confirmation) => {
  return confirmation && confirmation.userDetails && confirmation.userDetails.encryptedEmailAddress;
});

// const isVenmoPaymentConfirmationDisplayed = = createSelector(getOrderConfirmation, confirmation => {
//   return confirmation && confirmation.venmoPaymentConfirmationDisplayed;
// })

// function getVenmoUserId(state) {
//   const paymentLists = state.confirmation.orderConfirmation.paymentsList;
//   const venmoPayment = paymentLists && paymentLists.find(method => method.paymentMethod.toLowerCase() === 'venmo');
//   return venmoPayment ? venmoPayment.venmoUserId : '';
// }

/* istanbul ignore next */
const getIsOrderPending = createSelector(getOrderConfirmation, (orderConfirmation) => {
  return orderConfirmation && orderConfirmation.isOrderPending;
});

/* istanbul ignore next */
const getOrderDetails = createSelector(
  [getFullfilmentCentersMap, getOrderConfirmation],
  (fullfilmentCentersMap, orderConfirmation) => {
    return !fullfilmentCentersMap ? orderConfirmation?.orderDetails : null;
  }
);

/* istanbul ignore next */
const getOrderShippingDetails = createSelector(
  [getFullfilmentCentersMap, getOrderConfirmation],
  (fullfilmentCentersMap, orderConfirmation) => {
    return !fullfilmentCentersMap ? orderConfirmation?.shipping : null;
  }
);

// const getEstimatedRewards = createSelector(getOrderConfirmation, (orderConfirmation) => {
//   return orderConfirmation?.summary?.estimatedRewards ||
//     orderConfirmation?.summary?.estimatedRewards === 0
//     ? orderConfirmation?.summary?.estimatedRewards
//     : null;
// });

// const getPointsToNextReward = createSelector(getOrderConfirmation, orderConfirmation => {
//   return orderConfirmation.summary.pointsToNextReward || 0;
// })

// const getEarnedReward = createSelector(getOrderConfirmation, (orderConfirmation) => {
//   return orderConfirmation?.summary?.earnedReward || '';
// });

// const getAirmiles = createSelector(getOrderConfirmation, orderConfirmation =>{
//   return orderConfirmation && orderConfirmation.airmiles;
// })

/* istanbul ignore next */
const getOrderNumbersByFullfillmentCenter = createSelector(
  [getFullfilmentCentersMap, getHoldDate],
  (fullfilmentCentersMap, holdDate) => {
    return fullfilmentCentersMap
      ? {
          holdDate,
          fullfillmentCenterMap: fullfilmentCentersMap,
        }
      : null;
  }
);

//  const getBrierleySwitch = state => {
//   return state.session &&
//     state.session.siteDetails &&
//     state.session.siteDetails.isBrierleyEnabled !== undefined
//     ? state.session.siteDetails.isBrierleyEnabled
//     : true;
// };

// const shouldHideConfirmationEspot = createSelector(getPersonalDataState, personalData => {
//   return personalData && personalData.get('hideConfirmationEspot');
// })

const getCurrentSiteId = () => {
  return getAPIConfig().siteId;
};

const isCanadaSite = () => {
  return getCurrentSiteId() === constants.ROUTING_CONST.siteIds.ca;
};

/* istanbul ignore next */
const getUpdateOrderDetailsId = (option) => {
  const { referred } = getDynamicLabelValues('checkout.orderConfirmation');
  const content = referred && referred.length && referred.find((label) => label.name === option);
  return content && content.contentId;
};

/* istanbul ignore next */
const getUpdateOrderDetailsData = (state) => {
  return (
    state.Confirmation &&
    state.Confirmation.get('updateOrderDetails') &&
    state.Confirmation.get('updateOrderDetails').richText
  );
};

const getGiftServiceTotal = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.giftWrappingTotal;
});

const getTotalOrderSavings = createSelector(getConfirmationSummary, (summary) => {
  return summary && summary.totalOrderSavings;
});

const getVenmoOrderConfirmationContentId = (labelName) => {
  const { referred } = getDynamicLabelValues('checkout.orderConfirmation');
  return referred && referred.length && referred.find((label) => label.name === labelName);
};

const getVenmoOrderConfirmationContent = (state, labelName) => {
  const contentInfo = getVenmoOrderConfirmationContentId(labelName);
  const showDetailsContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX?.name === contentInfo?.name
  );
  return showDetailsContent && showDetailsContent.richText;
};

/* istanbul ignore next */
const getLedgerSummaryDataConfirmation = createSelector(
  getItemsCount,
  getSubTotal,
  getCouponsTotal,
  getSavingsTotal,
  getGiftServiceTotal,
  getShippingTotal,
  getTotalTax,
  getGrandTotal,
  getGiftCardsTotal,
  (state) => getCurrencySymbol(state),
  getIsOrderHasShipping,
  getTotalOrderSavings,
  (
    itemsCount,
    subTotal,
    couponsTotal,
    savingsTotal,
    giftServiceTotal,
    shippingTotal,
    taxesTotal,
    grandTotal,
    giftCardsTotal,
    currencySymbol,
    isOrderHasShipping,
    totalOrderSavings
    // eslint-disable-next-line max-params
  ) => {
    return {
      itemsCount,
      subTotal,
      couponsTotal,
      savingsTotal,
      giftServiceTotal,
      shippingTotal,
      taxesTotal,
      grandTotal,
      giftCardsTotal,
      orderBalanceTotal: grandTotal - giftCardsTotal,
      currencySymbol,
      isOrderHasShipping,
      totalOrderSavings,
    };
  }
);

const getMixOrderDetails = createSelector(getOrderConfirmation, (confirmation) => {
  return confirmation && confirmation.orderDetails;
});

export const getProductPartNumber = (item) =>
  (item && item.productInfo && item.productInfo.productPartNumber) || '';

export const getItemIds = (orderItems) => {
  return orderItems
    .map((item) => getProductPartNumber(item))
    .filter(Boolean)
    .join(',');
};

const getMostExpensiveItem = (cartItems) => {
  const expensiveItem = maxBy(
    cartItems,
    (item) => (item && item.productInfo && item.productInfo.offerPrice) || 0
  );
  return expensiveItem && expensiveItem.productInfo
    ? expensiveItem.productInfo.productPartNumber
    : '';
};

const getProductExcludeIds = createSelector(getOrderConfirmation, (confirmation) => {
  return confirmation && confirmation.orderItems ? getItemIds(confirmation.orderItems) : '';
});

const getExpensiveItem = createSelector(getOrderConfirmation, (confirmation) => {
  return confirmation && confirmation.orderItems
    ? getMostExpensiveItem(confirmation.orderItems)
    : '';
});

const getOrderItems = createSelector(
  getOrderConfirmation,
  (confirmation) => confirmation && confirmation.orderItems
);

export const returnCurrentCurrency = (currency) => {
  return currency === 'USD' || currency === 'CAD' ? '$' : currency;
};
export const getCurrentCurrency = (state) => {
  const currency = state.session && state.session.siteDetails.currency;
  return currency ? returnCurrentCurrency(currency) : '$';
};

const getConfirmationCartItems = createSelector(
  [getOrderItems, getCurrentCurrency],
  (items, currency) => {
    const cartItems = [];
    if (Array.isArray(items)) {
      items.forEach((item) => {
        cartItems.push({
          value: item.itemInfo && item.itemInfo.offerPrice,
          sku: item.productInfo.upc,
          pid: item.productInfo && item.productInfo.productPartNumber,
          quantity: item.itemInfo.quantity,
          currency,
        });
      });
    }
    return cartItems;
  }
);

const getOrderConfimationStatus = createSelector(
  getOrderConfirmation,
  (confirmation) => confirmation && confirmation.confirmationDone
);

export const getOrderNumber = createSelector(
  getOrderConfirmation,
  (confirmation) => confirmation?.orderDetails?.orderNumber
);

/**
 * re-select selector to provide create account success status
 */
const getHideCreateAccountForm = createSelector(
  getOrderConfirmation,
  (orderConfirmation) => orderConfirmation && orderConfirmation.hideCreateAccountForm
);

const confirmationOrderDetails = createSelector(getConfirmationSummary, (summary) => {
  const {
    estimatedRewards,
    subTotal,
    subTotalWithDiscounts,
    cartTotalAfterPLCCDiscount,
    earnedReward,
    pointsToNextReward,
  } = summary || {};
  return {
    estimatedRewards,
    subTotal,
    subTotalWithDiscounts,
    cartTotalAfterPLCCDiscount,
    earnedReward,
    pointsToNextReward,
  };
});

const getOrderTypes = (shipmentsData) => {
  const orderTypes = [];
  for (let i = 0; i < shipmentsData?.length; i += 1) {
    const obj = shipmentsData[i];
    let shipmentMethod = (obj?.shippingMethod && obj?.shippingMethod?.name?.toLowerCase()) || '';
    if (shipmentMethod?.includes('boss')) {
      shipmentMethod = 'boss';
    } else if (shipmentMethod?.includes('bopis')) {
      shipmentMethod = 'bopis';
    } else {
      shipmentMethod = 'standard';
    }
    if (shipmentMethod && !orderTypes?.includes(shipmentMethod)) {
      orderTypes?.push(shipmentMethod);
    }
  }
  return orderTypes;
};

const getOrderNPlccICFiredData = (state) => {
  const { isPlccICFired } =
    state && state?.AddedToBagReducer ? JSON.parse(JSON.stringify(state?.AddedToBagReducer)) : '';
  const orderObject = state?.Confirmation?.get('orderConfirmation') || {};
  return {
    orderObject,
    isPlccICFired,
  };
};

const getCartType = createSelector(getOrderNPlccICFiredData, (data) => {
  const { orderObject = {}, isPlccICFired = {} } = data;
  const instantCheckoutConstant = 'Instant Checkout';
  let cartType = 'standard';
  const shipmentsData = orderObject && orderObject?.shipments;
  if (!shipmentsData) return '';
  const orderTypes = getOrderTypes(shipmentsData);
  if (orderTypes?.length > 1) {
    cartType = 'mix';
  } else if (orderTypes?.length === 1) {
    const [type] = orderTypes;
    cartType = type;
  }
  if (isPlccICFired) {
    cartType = cartType?.concat('|', instantCheckoutConstant);
  }
  return cartType;
});

const getEbboOffers = (state) => {
  return (state.Confirmation && state.Confirmation.get('ebboOffers')) || {};
};

const getIsEbboModalOpen = (state) => {
  return state.Confirmation && state.Confirmation.get('isEbboModalOpen');
};

export default {
  getOdmLoading,
  getOrderConfirmation,
  getOrderEmailAddress,
  getCurrentSiteId,
  getItemsCount,
  getSubTotal,
  getCouponsTotal,
  getSavingsTotal,
  // getGrandTotal,
  // getSummary,
  getFullfilmentCentersMap,
  getHoldDate,
  // getInitialCreateAccountValues,
  getIsOrderHasShipping,
  // getFullfilmentCentersMap,
  // getHoldDate,
  getInitialCreateAccountValues,
  // getIsOrderHasShipping,
  getEarnedPlaceCashValue,
  // getPlaceCashSpotEnabled,
  getPersonalizedCoupons,
  getEncryptedEmailAddress,
  // getPeronsalizedCoupons,
  // isVenmoPaymentConfirmationDisplayed,
  getConfirmationSummary,
  // getVenmoUserId,
  getIsOrderPending,
  getOrderDetails,
  getOrderShippingDetails,
  // getEstimatedRewards,
  // getPointsToNextReward,
  // getEarnedReward,
  // getAirmiles,
  getOrderNumbersByFullfillmentCenter,
  // getBrierleySwitch,
  // shouldHideConfirmationEspot
  isCanadaSite,
  getUpdateOrderDetailsId,
  getUpdateOrderDetailsData,
  getLedgerSummaryDataConfirmation,
  getVenmoOrderConfirmationContentId,
  getVenmoOrderConfirmationContent,
  getProductExcludeIds,
  getExpensiveItem,
  getMixOrderDetails,
  getOrderNumber,
  getOrderItems,
  getOrderConfimationStatus,
  getHideCreateAccountForm,
  getAllShipments,
  getCsthOrderNo,
  getOrderNoArray,
  confirmationOrderDetails,
  getConfirmationCartItems,
  getCartType,
  getEbboOffers,
  getIsEbboModalOpen,
};
